var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.close,
          expression: "close",
        },
      ],
      staticClass: "expandable-button",
    },
    [
      _c(
        "ib-button",
        {
          staticClass: "custom-button-red dark-grey-text fw-400 fs6 menu-body",
          on: { click: _vm.open },
        },
        [
          _c("span", { staticClass: "insetx-4" }, [
            _vm._v(_vm._s(_vm.selectedCurrency)),
            _c("svg", { attrs: { viewBox: "0 0 50 50" } }, [
              _c("path", { attrs: { d: "M4 17l21 22 21-22z" } }),
            ]),
          ]),
        ]
      ),
      _vm.showOptions
        ? _c("div", { staticClass: "floating-options" }, [
            _c(
              "div",
              { staticClass: "currency-selectors" },
              _vm._l(_vm.items, function (item, index) {
                return _c(
                  "ib-row",
                  { key: item.key },
                  [
                    _c(
                      "ib-col",
                      [
                        _c(
                          "ib-button",
                          {
                            staticClass: "custom-button-currency",
                            class: {
                              "active-button-currency":
                                item.value === _vm.selectedCurrency,
                            },
                            attrs: { width: "100%" },
                            on: {
                              click: function ($event) {
                                return _vm.select(index)
                              },
                            },
                          },
                          [
                            _c("span", { staticClass: "fw-400 grey-text" }, [
                              _vm._v(_vm._s(_vm.$t(item.name))),
                            ]),
                            item.value === _vm.selectedCurrency
                              ? _c("span", [
                                  _c(
                                    "svg",
                                    {
                                      attrs: {
                                        viewBox: "0 0 24 24",
                                        fill: "#0a0",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          d: "M24 12c0-6.6-5.4-12-12-12S0 5.4 0 12s5.4 12 12 12 12-5.4 12-12zm-2.8-4.7l-11.3 11.3-.8.8-6.25-6.25 2.75-2.75 3.5 3.5 9.3-9.3 2.75 2.75z",
                                        },
                                      }),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }),
              1
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }